import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { addRegistrationAPI } from '../../../services/conference-details-service';

const initialState = {
  payment: undefined,
  loading: false,
  error: undefined,
};

export const addRegistration = createAsyncThunk(
  'confRegistration/addRegistration',
  async (payload, thunkAPI) => {
    try {
      const resp = await addRegistrationAPI(payload);
      return resp;
    } catch (error) {
      console.error("error",error);
      return thunkAPI.rejectWithValue('something went wrong');
    }
  }
);

const confRegistrationPaymentReducer = createSlice({
  name: 'confRegistration',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(addRegistration.rejected, (state, action) => {
        state.loading = false;
        state.payment = action.payload;
        state.error = action.payload;
      })
      .addCase(addRegistration.pending, (state) => {
        state.loading = true;
      })
      .addCase(addRegistration.fulfilled, (state, action) => {
        state.loading = false;
        state.payment = action.payload;
        state.error = action.payload;
      });
  },
});

export default confRegistrationPaymentReducer.reducer;
